export const Designer = {
  allTasksCompletion: 'showAllTasksCompletion',
  allTasksTitleVisibility: 'showAllTasksTitle',
  shouldGivePlayerScore: 'shouldGivePlayerScore',
  shouldGiveTeamScore: 'shouldGiveTeamScore'
};

export const PreGame = {
  lobby: 'showPreGameLobby',
  teamRequired: 'isPreGameTeamRequired',
  teams: 'showPreGameTeams',
  createTeams: 'showPreGameCreateTeams',
  joinLeaveTeams: 'showPreGameJoinLeaveTeams',
  inventory: 'showPreGameInventory',
  roles: 'showPreGameRoles',
  scoreboard: 'showPreGameScoreboard',
  chats: 'showPreGameChat',
  facilitatorChat: 'showPreGameFacilitatorChat',
  allPlayerChat: 'showPreGameAllPlayerChat',
  directChat: 'showPreGameDirectChat',
  teamChat: 'showPreGameTeamChat',
  groupChat: 'showPreGameGroupChat',
  trade: 'showPreGameTrade',
  onDemandTask: 'showPreGameOnDemandTask',
  changePlayerName: 'enablePreGameChangePlayerName',
  playerProfile: 'profilePreGamePlayerJoin'
};

export const InGame = {
  information: 'showInGameInfo',
  teams: 'showInGameTeams',
  createTeams: 'showInGameCreateTeams',
  joinLeaveTeams: 'showInGameJoinLeaveTeams',
  inventory: 'showInGameInventory',
  roles: 'showInGameRoles',
  scoreboard: 'showInGameScoreboard',
  playerTeamScore: 'showInGamePlayerTeamScore',
  leaderboard: 'showInGameLeaderboard',
  chats: 'showInGameChat',
  facilitatorChat: 'showInGameFacilitatorChat',
  allPlayerChat: 'showInGameAllPlayerChat',
  directChat: 'showInGameDirectChat',
  teamChat: 'showInGameTeamChat',
  groupChat: 'showInGameGroupChat',
  trade: 'showInGameTrade',
  tasksRequireProximity: 'tasksRequireProximity',
  setTaskProximity: 'setTaskProximity',
  premessage: 'enablePremessageOutsideRange',
  otherPlayerOrTeam: 'showOtherPlayerOrTeamOnMap',
  showPlayerScoreOnMap: 'showPlayerScoreOnMap',
  showPlayerDetailByClickOnMap: 'showPlayerDetailByClickOnMap',
  onDemandTask: 'showInGameOnDemandTask',
  changePlayerName: 'enableInGameChangePlayerName'
};
